import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetProjectPlanDetails = createAsyncThunk(
  "ProjectPlanDetails/GetProjectPlanDetails",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PS_ProjectSummaryEntity/GetProjectSummaryData",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "datdfdfdfdfdfa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateProjectPlanDetails = createAsyncThunk(
  "ProjectPlanDetails/ValidateProjectPlanDetails",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PS_ProjectSummaryEntity/ValidateProjectSummary",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });

        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ProjectPlanDetails = createSlice({
  name: "ProjectPlanDetails",
  initialState: {
    ProjectPlanDetails: {},
    loadingGetProjectPlanDetails: false,
    errorGetProjectPlanDetails: null,

    ProjectPlanDetailsValidate: [],
    loadingProjectPlanDetailsValidate: false,
    errorProjectPlanDetailsValidate: null,
  },
  reducers: {
    SetProjectPlanDetails: (state, action) => {
      state.ProjectPlanDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetProjectPlanDetails.pending, (state, action) => {
        state.loadingGetProjectPlanDetails = true;
        state.ProjectPlanDetails = action.payload;
        state.errorGetProjectPlanDetails = null;
      })
      .addCase(GetProjectPlanDetails.fulfilled, (state, action) => {
        state.loadingGetProjectPlanDetails = false;
        state.ProjectPlanDetails = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetProjectPlanDetails.rejected, (state, action) => {
        state.loadingGetProjectPlanDetails = false;
        state.errorGetProjectPlanDetails = action.payload;
      })
      builder
      .addCase(ValidateProjectPlanDetails.pending, (state, action) => {
        state.loadingProjectPlanDetailsValidate = true;
        state.ProjectPlanDetailsValidate = action.payload;
        state.errorProjectPlanDetailsValidate = null;
      })
      .addCase(ValidateProjectPlanDetails.fulfilled, (state, action) => {
        state.loadingProjectPlanDetailsValidate = false;
        state.ProjectPlanDetailsValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateProjectPlanDetails.rejected, (state, action) => {
        state.loadingProjectPlanDetailsValidate = false;
        state.errorProjectPlanDetailsValidate = action.payload;
      });
  },
});
export const { SetProjectPlanDetails } = ProjectPlanDetails.actions;

export default ProjectPlanDetails.reducer;
